import './FloatingLessonBubbleCf.css';

export const FloatingLessonBubbleCf = () => {
  return (
    <div className="lesson-bubble-wrapper-cf">
      <div className="start-label-cf">START</div>
    </div>
  );
};
